// **********************************************************
// Image Slider
// **********************************************************

const imageSlider = document.querySelectorAll('[data-slider="image-slider"]');

const imageSliderOptions = {
  sliderPerView: 1,
  spaceBetween: 10,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

imageSlider.forEach((el) => {
  const imageSliderEle = el.closest('.image-slider');

  const arrowRight = imageSliderEle.querySelector('.arrow-right');
  const arrowLeft = imageSliderEle.querySelector('.arrow-left');

  imageSliderOptions.navigation.nextEl = arrowRight;
  imageSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, imageSliderOptions);
});
